@import '@hevoio/hevo-ui-toolkit/styles/variables';

.formErrorWrapper {
  display: flex;
  padding: $spacer * 0.5 $spacer * 0.75;
  border-radius: $border-radius-md;
  align-items: flex-start;
  color: $light-text;
  background: $error;

  &.fadedError {
    background: $error;
    background: $error-faded-2;
    border: solid $border-width $error-border-1;
    color: $error;
  }

  .content {
    flex: 1;
    align-self: center;
    word-wrap: break-word;
    min-width: 0;
    font-weight: $font-weight-medium;
    text-align: left;
  }

  .thumbnail {
    margin-right: $spacer * 0.75;
    flex-shrink: 0;
    font-size: $icon-size-base * 1.25;
  }
}
